import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const NewReportingDateDialog = ({ open, onOpenChange, date, onDateChange, onCreate }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="new-reporting-date-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading tracking-tight">Create new reporting date</DialogTitle>
        <DialogDescription>
          Pick any date — the label is auto-derived (e.g. <span className="font-mono">Jun 2025</span>).
          You&apos;ll be able to enter holdings for every source under this date.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <div>
          <Label htmlFor="snap-date" className="overline">Reporting date</Label>
          <Input id="snap-date" type="date" value={date} onChange={(e) => onDateChange(e.target.value)} data-testid="new-snap-date-input" />
        </div>
      </div>
      <DialogFooter>
        <button className="btn-secondary" onClick={() => onOpenChange(false)}>Cancel</button>
        <button className="btn-primary" onClick={onCreate} data-testid="create-reporting-date-confirm">Create</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default NewReportingDateDialog;
